import React, { FC } from 'react';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import MultiSelectionFilter from '@components/Templates/FilterPanel/MultiSelectionFilter';
import { FEATURES } from '@common/types';

type Props = {};

const FeaturesFilter: FC<Props> = ({}) => {
  const {
    state: { filters },
  } = useTemplatesContext();

  return (
    <MultiSelectionFilter
      selectedValue={filters.features}
      items={FEATURES}
      langTokenPrefix={'marketplace.templates-page.feature-'}
      updatedQueryParam={'features'}
      dataHook={'features'}
      type={'features'}
    />
  );
};

export default FeaturesFilter;
